var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open_eye_icon",
    transform: "translate(-309 -1321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M26,0H0V26H26Z",
    transform: "translate(309 1321)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2117",
    "data-name": "Group 2117",
    transform: "translate(311.43 1323.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M2.029,11.205a.868.868,0,0,1,0-.548,9,9,0,0,1,17.083,0,.856.856,0,0,1,0,.548,9,9,0,0,1-17.082,0Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M14.144,11.572A2.572,2.572,0,1,1,11.572,9,2.572,2.572,0,0,1,14.144,11.572Z",
    transform: "translate(-1.001 -0.642)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/open_eye_icon.b1e7abeda2c870fdf18237f104be80af.svg";
export { ForwardRef as ReactComponent };